/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 15 de 05 de 2026
 */

import { useEffect, useRef } from "react";

import * as THREE from "three";

import NET from "vanta/dist/vanta.net.min";
import FOG from "vanta/dist/vanta.fog.min";

import { colors } from "../../../enums/colors";

// Vanta expects numeric hex (0xRRGGBB); colors enum stores "#RRGGBB" strings.
const toHex = (color) => parseInt(color.replace("#", ""), 16);

export default function VantaBackground() {

    /*
    |--------------------------------------------------------------------------
    | Refs
    |--------------------------------------------------------------------------
    */

    const dotsRef = useRef(null);

    const linesRef = useRef(null);
    const linesCapa1Ref = useRef(null);

    const fogRef = useRef(null);

    useEffect(() => {

        const fogEffect = FOG({
            el: fogRef.current,
            THREE,
            highlightColor: toHex(colors.primary600),
            midtoneColor: toHex(colors.primary800),
            lowlightColor: toHex(colors.primary400),
            baseColor: toHex(colors.general950),
            blurFactor: 0.3,
            speed: 0.8,
            zoom: .9,
            mouseControls: false,
            touchControls: false,
            gyroControls: false
        });

        const dotsEffect = NET({
            el: dotsRef.current,
            THREE,
            maxDistance: 0,
            spacing: 20,
            showDots: true,
            color: toHex(colors.primary300),
            backgroundColor: toHex(colors.general950),
            backgroundAlpha: 0,
            points: 5,
            mouseControls: false,
            touchControls: false,
            gyroControls: false
        });
        dotsEffect.scene.traverse((obj) => {
            if (obj.material && obj.material.color) {
                obj.material.blending = THREE.AdditiveBlending;
            }

        });
        const linesEffect = NET({
            el: linesRef.current,
            THREE,
            maxDistance: 35,
            spacing: 30,
            points: 7,
            showDots: false,
            color: toHex(colors.primary600),
            backgroundColor: toHex(colors.general950),
            backgroundAlpha: 0,
            mouseControls: false,
            touchControls: false,
            gyroControls: false
        });
        linesEffect.scene.traverse((obj) => {
            if (obj.material && obj.material.color) {
                obj.material.color.setHex(toHex(colors.primary600));
                obj.material.transparent = true;
                obj.material.opacity = 0.45;
            }

        });

        const lineCapa1Effect = NET({
            el: linesCapa1Ref.current,
            THREE,
            maxDistance: 35,
            spacing: 30,
            showDots: false,
            color: toHex(colors.primary600),
            backgroundColor: toHex(colors.general950),
            backgroundAlpha: 0,
            points: 5,
            mouseControls: false,
            touchControls: false,
            gyroControls: false
        });
        lineCapa1Effect.scene.traverse((obj) => {
            if (obj.material && obj.material.color) {
                obj.material.color.setHex(toHex(colors.primary800));
                obj.material.transparent = true;
                obj.material.opacity = 0.8;
            }

        });


        return () => {

            if (fogEffect) fogEffect.destroy();

            if (dotsEffect) dotsEffect.destroy();

            if (linesEffect) linesEffect.destroy();

            if (lineCapa1Effect) lineCapa1Effect.destroy();
        };

    }, []);

    return (
        <div className="vanta-wrapper">

            <div ref={dotsRef} className="vanta-layer vanta-dots vanta-net-bright"/>

            <div className="vanta-net-mask">
                <div ref={linesCapa1Ref} className="vanta-layer vanta-lines vanta-lines-back"/>
                <div ref={linesRef} className="vanta-layer vanta-lines"/>
            </div>

            <div className="vanta-fog-mask">
                <div ref={fogRef} className="vanta-layer vanta-fog"/>
            </div>

        </div>
    );
}
